import React, { useState, useEffect, useRef } from "react";
import VERSION_INFO from "../../version";

const POLL_INTERVAL_MS = 5 * 60 * 1000; // check every 5 minutes

const VersionBanner = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const loadedVersion = useRef(VERSION_INFO.version);

  const checkForUpdate = async () => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
      if (!res.ok) return;
      const data = await res.json();
      if (data.version && data.version !== loadedVersion.current) {
        setUpdateAvailable(true);
      }
    } catch (_) {
      // silently ignore network errors
    }
  };

  useEffect(() => {
    checkForUpdate();
    const interval = setInterval(checkForUpdate, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: "#1d5ca7",
        color: "#fff",
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        fontSize: "14px",
        fontWeight: "500",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
      }}
    >
      <span>
        A new version of the app is available. Please{" "}
        <strong>log out and log back in</strong> to get the latest updates.
      </span>
      <button
        onClick={() => setUpdateAvailable(false)}
        style={{
          background: "rgba(255,255,255,0.2)",
          border: "1px solid rgba(255,255,255,0.5)",
          color: "#fff",
          padding: "4px 12px",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "13px",
          whiteSpace: "nowrap",
        }}
      >
        Dismiss
      </button>
    </div>
  );
};

export default VersionBanner;
